module.exports = __webpack_public_path__ + "static/9e25fcbc.discount.png";